import { actionTypes } from '../../../../common/constants/actionTypes';

export const setCookieBannerVisibilityAction = (isVisible: boolean) => ({
  payload: isVisible,
  type: actionTypes.SET_COOKIE_BANNER_VISIBILITY
});


// WEBPACK FOOTER //
// ./src/common/components/cookieBanner/actions/setCookieBannerVisibility.ts